import React from "react";
import { motion } from "framer-motion";

export default function MarqueeQuote() {
    return (
        <section
            data-testid="marquee-quote"
            className="relative py-28 sm:py-36 border-y border-white/5 overflow-hidden"
        >
            <div
                className="absolute inset-0 opacity-40"
                style={{
                    background:
                        "radial-gradient(ellipse at center, rgba(122,0,0,0.18), transparent 70%)",
                }}
            />
            <div className="relative max-w-5xl mx-auto px-6 sm:px-10 text-center">
                <div className="overline mb-8">Doctrine · No. 01</div>
                <motion.blockquote
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
                    className="font-serif-display italic text-3xl sm:text-4xl lg:text-5xl leading-[1.15] text-[#f4f4f0]"
                >
                    “You don’t ask for power. You{" "}
                    <span className="text-[#990000] not-italic">
                        design the environment
                    </span>{" "}
                    where they have no choice but to hand it to you.”
                </motion.blockquote>
                <div className="mt-10 divider-ornament text-sm">
                    <span>V · V</span>
                </div>
            </div>
        </section>
    );
}
